import React from "react";
import "./Center.scss";

export default function Center({ children }) {
  return <div className="center-component">{children}</div>;
}
